import { makeStyles } from "@fluentui/react-components";
import IPageMarquee from "../../../models/page/pageComponents/IPageMarquee";

const useStyles = makeStyles({
    wrapper: {
        width: "100%",
        overflow: "hidden",
        padding: "1.5rem 0",
        boxSizing: "border-box"
    },
    viewport: {
        width: "100%",
        overflow: "hidden"
    },
    track: {
        width: "100%",
        display: "flex",
        animationName: {
            "0%": {
                transform: "translateX(0)"
            },
            "50%": {
                transform: "translateX(calc(100% - var(--marquee-text-width, 300px)))"
            },
            "100%": {
                transform: "translateX(0)"
            }
        },
        animationDuration: "22s",
        animationTimingFunction: "ease-in-out",
        animationIterationCount: "infinite"
    },
    text: {
        display: "inline-block",
        width: "max-content",
        maxWidth: "100%",
        margin: 0,
        fontSize: "var(--fontSizeHero800)",
        lineHeight: "var(--lineHeightHero800)",
        fontWeight: "var(--fontWeightBold)",
        whiteSpace: "nowrap"
    }
});

export default function Marquee(props: IPageMarquee) {
    const styles = useStyles();

    if (!props.text) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.viewport}>
                <div
                    className={styles.track}
                    style={{ ["--marquee-text-width" as any]: `${Math.max(props.text.length * 22, 180)}px` }}
                >
                    <h1 className={styles.text}>{props.text}</h1>
                </div>
            </div>
        </div>
    );
}